// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__17GdN","approved":"Status_approved__1ijzo","rejected":"Status_rejected__1bTv2","expired":"Status_expired__2iUwa","label":"Status_label__1scop"};